import { render } from "./backendNotificationNewChatMessage.vue?vue&type=template&id=0d1d3b8d&ts=true"
import script from "./backendNotificationNewChatMessage.vue?vue&type=script&lang=ts"
export * from "./backendNotificationNewChatMessage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__